import { PricesPatchResponse } from '@cemex-core/cmx-api/models/prices/prices-patch-res';
import { Action } from '@ngrx/store';
import { OrderConfirmationDetail } from '@ordersnproducts/modules/order-builder/modules/adt-specification/store/reducers/adt-reducers/order-confirmation.reducer';
import { OrderActionType } from '@cemex-core/cmx-api';

export enum AdtOrderConfirmationActionTypes {
  POST_ORDER_CONFIRMATION = '[ADT Order Confirmation] Post Order Confirmation',
  UPDATE_ORDER_CONFIRMATION = '[ADT Order Confirmation] Update Order Confirmation',
  LOAD_ORDER_CONFIRMATION_DRAFT = '[ADT Order Confirmation] Load Order Confirmation Draft',
  FETCH_ORDER_CONFIRMATION_DETAIL = '[ADT Order Confirmation] Fetch Order Confirmation Detail',
  LOAD_ORDER_CONFIRMATION_DETAIL = '[ADT Order Confirmation] Load Order Confirmation Detail',
  FETCH_ORDER_PRICES = '[ADT Order Confirmation] Fetch Order Prices',
  LOAD_ORDER_PRICES = '[ADT Order Confirmation] Load Order Prices',
  STOP_LOADING = '[ADT Order Confirmation] Stop Loading',
  RESET_ORDER_CONFIRMATION = '[ADT Order Confirmation] Reset Order Confirmation',
  RESET_ORDER_CONFIRMATION_DETAIL = '[ADT Order Confirmation] Reset Order Confirmation Detail',
  RESET_ORDER_CONFIRMATION_DRAFT = '[ADT Order Confirmation] Reset Order Confirmation Detail',
}

/**
 * Reset order confirmation detail
 */
export class AdtResetAdtOrderConfirmationDetailAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION_DETAIL;

  constructor() {}
}

/**
 * Reset order confirmation detail
 */
export class AdtResetAdtOrderConfirmationDraftAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION_DRAFT;

  constructor() {}
}

/**
 * Update order confirmation
 */
export class UpdateAdtOrderConfirmationAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.UPDATE_ORDER_CONFIRMATION;

  constructor(public payload: any) {}
}

/**
 * Post order confirmation
 */
export class PostAdtOrderConfirmationAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.POST_ORDER_CONFIRMATION;

  constructor(public payload: any) {}
}

/**
 * Load order confirmation draft
 */
export class LoadOrderConfirmationDraftAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.LOAD_ORDER_CONFIRMATION_DRAFT;

  constructor(public payload: any) {}
}

/**
 * Fetch order confirmation price
 */
export class FetchOrderConfirmationDetailAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.FETCH_ORDER_CONFIRMATION_DETAIL;

  constructor(public payload: { orderId: number; action: OrderActionType }) {}
}

/**
 * Load order confirmation price
 */
export class LoadOrderConfirmationDetailLAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.LOAD_ORDER_CONFIRMATION_DETAIL;

  constructor(public payload: OrderConfirmationDetail) {}
}

/**
 * Fetch order prices
 */
export class FetchOrderPricesAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.FETCH_ORDER_PRICES;

  constructor(public payload: number) {}
}

/**
 * Load order prices
 */
export class LoadOrderPricesAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.LOAD_ORDER_PRICES;

  constructor(public payload: PricesPatchResponse) {}
}

/**
 * Reset order confirmation
 */
export class AdtResetOrderConfirmationAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.RESET_ORDER_CONFIRMATION;

  constructor() {}
}

/**
 * Stop loading
 */
export class AdtStopOrderConfirmationLoaderAction implements Action {
  readonly type = AdtOrderConfirmationActionTypes.STOP_LOADING;

  constructor() {}
}

export type AdtOrderConfirmationActions =
  | PostAdtOrderConfirmationAction
  | LoadOrderConfirmationDraftAction
  | FetchOrderConfirmationDetailAction
  | LoadOrderConfirmationDetailLAction
  | FetchOrderPricesAction
  | LoadOrderPricesAction
  | UpdateAdtOrderConfirmationAction
  | AdtResetAdtOrderConfirmationDraftAction
  | AdtResetAdtOrderConfirmationDetailAction
  | AdtStopOrderConfirmationLoaderAction
  | AdtResetOrderConfirmationAction;
